import { render, staticRenderFns } from "./AStaffDetailPrivilege.vue?vue&type=template&id=92a56eba&scoped=true"
import script from "./AStaffDetailPrivilege.vue?vue&type=script&lang=js"
export * from "./AStaffDetailPrivilege.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailPrivilege.vue?vue&type=style&index=0&id=92a56eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a56eba",
  null
  
)

export default component.exports